import cn from 'clsx';
import { TextareaHTMLAttributes, forwardRef } from 'react';

import s from './TextareaTextField.module.scss';

export interface TextareaTextFieldProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean;
}

const TextareaTextField = forwardRef<HTMLTextAreaElement, TextareaTextFieldProps>(({ error, disabled, className, ...props }, ref) => {
  return (
    <div
      className={cn(
        s.wrapper,
        {
          [s.disabled as string]: disabled,
          [s.error as string]: error
        },
        className
      )}
    >
      <textarea disabled={disabled} className={cn(s.field, s.scroll)} {...props} ref={ref} />
    </div>
  );
});

export default TextareaTextField;
